import { Mark } from "@tiptap/core";

export const Language = Mark.create({
  name: "language",
  renderHTML() {
    return ["span", 0];
  },
});
